import { createContext } from "react";
import type { GemmaStatus, GenerateRequest } from "./types";

export type GemmaContextValue = {
  status: GemmaStatus;
  generate: (req: GenerateRequest) => Promise<string>;
  load: () => Promise<void>;
  unload: () => void;
};

export const GemmaContext = createContext<GemmaContextValue | null>(null);
